import TransactionsTable from "../../../../components/TransactionsTable";

const TransactionsRightSide = () => {
  return (
    <>
      <TransactionsTable />
    </>
  );
};

export default TransactionsRightSide;
